import Router from "vue-router"

Vue.use(Router)

const defaultRoute = [
    {
        path: '/',
        redirect: 'login'
    }
]

const notFoundComponent = [
    {
        path: '*',
        component: Vue.extend({
            template: '<h2>Not Found: {{ $route.fullPath }}</h2>'
        })
    }
]

// auto-load routes from ./modules folder
let routes = []

const requireModule = require.context('./modules/', false, /\.js$/)

requireModule.keys().forEach(filename => {
    let moduleRoutes = requireModule(filename).default || requireModule(filename)

    if (Array.isArray(moduleRoutes)) {
        routes.push(...moduleRoutes)
    } else if (typeof moduleRoutes === 'object') {
        routes.push(moduleRoutes)
    } else {
        throw new Error('Module routes must be Array or Object')
    }
})
//

const AppRouter = new Router({
    routes: [
        ...routes,
        ...defaultRoute,
        ...notFoundComponent
    ]
})

AppRouter.beforeEach((to, from, next) => {
    if( window._appRedirected ) {
        next(false)
        return
    }

    next()
})

AppRouter.afterEach((to, from) => {
    window.top.postMessage({type: 'hashchange', hash: to.fullPath}, "*");
})

export default AppRouter
